"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("@ori-ui/mui-bundle/material/utils");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _utils.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  fillRule: "evenodd",
  d: "M16.854 3.56a.5.5 0 0 0-.707 0l-.086.086a.5.5 0 0 0 0 .707l.293.293 3.293 3.293a.5.5 0 0 0 .707 0l.085-.086a.5.5 0 0 0 0-.707zm-1.415-.707a1.5 1.5 0 0 1 2.122 0l3.585 3.586a1.5 1.5 0 0 1 0 2.122l-.085.085a1.5 1.5 0 0 1-2.015.097L15.6 13.051a3.5 3.5 0 0 1-.17 3.807l-.337.472a1.5 1.5 0 0 1-2.281.189L10.5 15.207l-5.48 5.48a1.5 1.5 0 0 1-.586.362l-1.276.425a.5.5 0 0 1-.632-.632l.43-1.29a1.5 1.5 0 0 1 .332-.556l5.342-5.66-2.149-2.148a1.5 1.5 0 0 1 .189-2.281l.813-.581a3.005 3.005 0 0 1 3.528.025l4.246-3.397a1.5 1.5 0 0 1 .097-2.015zm.524 2.817-4.214 3.37 3.21 3.21 3.371-4.214zm-6.626 8.374-5.322 5.638a.5.5 0 0 0-.11.186l-.114.341.327-.109a.5.5 0 0 0 .195-.12l5.48-5.48zm1.31-4.69a2.004 2.004 0 0 0-2.583-.214l-.813.58a.5.5 0 0 0-.063.761l6.33 6.33a.5.5 0 0 0 .761-.062l.337-.472a2.5 2.5 0 0 0-.267-3.22z",
  clipRule: "evenodd"
}), 'Pin');
